<template lang="pug">
.sign
  .sign_block.flex_v
    h4.eng {{ engTitle }}
    h4.tw {{ title }}
</template>

<script>
export default {
  name: "Sign",
  props: {
    title: String,
    engTitle: String,
  },
  data() {
    return {
      // selected: Boolean,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/sign";
</style>
